var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconBlockGraphics = function SvgIconBlockGraphics(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Ret\\xE2ngulo 1990",
    fill: "none",
    d: "M0 0h38.754v38.754H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 5685"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Ret\\xE2ngulo 1978",
    fill: "#fff",
    opacity: 0.8,
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 5687"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 5686",
    clipPath: "url(#a)",
    transform: "translate(5.623 5.623)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 4591",
    d: "M19.377.9a18.477 18.477 0 1 0 18.477 18.477A18.476 18.476 0 0 0 19.377.9M5.006 19.377a14.342 14.342 0 0 1 22.96-11.493L7.884 27.966a14.271 14.271 0 0 1-2.878-8.59m14.371 14.371a14.271 14.271 0 0 1-8.59-2.878l20.082-20.082a14.342 14.342 0 0 1-11.493 22.96",
    fill: "#4b4b4b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 4592",
    d: "M19.377 38.754a19.377 19.377 0 1 1 0-38.754 19.377 19.377 0 1 1 0 38.753m0-36.954a17.578 17.578 0 1 0 17.577 17.578A17.6 17.6 0 0 0 19.376 1.8m.029 32.847h-.031a15.258 15.258 0 0 1-9.129-3.06l-.826-.623L30.966 9.418l.623.829a15.242 15.242 0 0 1-12.184 24.4m-7.22-3.9a13.467 13.467 0 0 0 7.193 2.1h.027a13.518 13.518 0 0 0 8.077-2.7 13.443 13.443 0 0 0 3.262-17.965Zm-4.4-1.41-.624-.826a15.243 15.243 0 0 1 12.152-24.4h.03a15.333 15.333 0 0 1 9.16 3.059l.828.623Zm-1.879-9.961a13.472 13.472 0 0 0 2.1 7.193L26.567 8.01a13.533 13.533 0 0 0-7.22-2.1h-.026A13.458 13.458 0 0 0 5.906 19.376Z",
    fill: "#fff"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconBlockGraphics, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-block-graphics.a3af4ddb.svg";
export { ForwardRef as ReactComponent };